import type { RoundListItem } from "../../../shared/contracts/product-pages.js";

const key = (accountId: string, id: string) =>
  `fairway-rivalry:result-seen:${accountId}:${id}`;
export function markResultSeen(accountId: string, id: string): void {
  try {
    localStorage.setItem(key(accountId, id), "1");
  } catch {
    /* Storage is optional. */
  }
  window.dispatchEvent(new CustomEvent("fairway-result-seen"));
}
export function latestUnseenResult(
  rounds: RoundListItem[],
  accountId: string,
): RoundListItem | null {
  const latest = rounds
    .filter(
      (round) => round.state === "completed" && !round.mainResult?.reviewStatus,
    )
    .sort((a, b) =>
      (b.completedAt ?? b.playedAt ?? "").localeCompare(
        a.completedAt ?? a.playedAt ?? "",
      ),
    )[0];
  if (!latest) return null;
  try {
    if (localStorage.getItem(key(accountId, latest.id))) return null;
  } catch {
    /* Still offer the result. */
  }
  return latest;
}
